export class ValidationServiceProvider {
    constructor() { }
    static getInstance() {
        if (!ValidationServiceProvider._instance) {
            throw new Error('A ValidationService instance is not set.');
        }
        return ValidationServiceProvider._instance;
    }
    static setInstance(service) {
        ValidationServiceProvider._instance = service;
    }
    static resetInstance() {
        ValidationServiceProvider._instance = null;
    }
}
ValidationServiceProvider._instance = null;
//# sourceMappingURL=validationServiceProvider.js.map